<!--
 * @Description: 
 * @Author: Ingyi
 * @Date: 2021-09-05 18:01:56
 * @LastEditors: Ingyi
 * @LastEditTime: 2021-09-05 20:16:14
-->
<template>
  <div class="userCenter">
   
    <div style="width: 1280px; margin: 0 auto; display: flex;padding-top:20px;">
      <div class="user-center-left">
        <a-menu style="width: 310px" mode="inline" @click="handleClick">
          <a-sub-menu key="sub1">
            <span slot="title"><a-icon type="mail" /><span>专利服务</span></span>
            <a-menu-item key="/userCenter/patent_register"> 专利申请 </a-menu-item>
            <a-menu-item key="/userCenter/patent"> 专利申诉 </a-menu-item>
            <a-menu-item key="/userCenter/patent_towingpipe"> 专利托管 </a-menu-item>
          </a-sub-menu>
          <a-sub-menu key="sub2">
            <span slot="title"><a-icon type="mail" /><span>商标服务</span></span>
            <a-menu-item key="/userCenter/brand_design"> 商标设计 </a-menu-item>
            <a-menu-item key="/userCenter/brand"> 商标申请 </a-menu-item>
            <a-menu-item key="/userCenter/brand_transfer"> 商标转让 </a-menu-item>
          </a-sub-menu>
          <a-sub-menu key="sub3">
            <span slot="title"><a-icon type="mail" /><span>地理标识服务</span></span>
            <a-menu-item key="/userCenter/geography_register"> 地理标识申请 </a-menu-item>
            <a-menu-item key="/userCenter/geography_range"> 地理标识保护 </a-menu-item>
          </a-sub-menu>
          <a-sub-menu key="sub4">
            <span slot="title"><a-icon type="mail" /><span>运营服务</span></span>
            <a-menu-item key="/userCenter/order"> 订单管理 </a-menu-item>
            <a-menu-item key="/userCenter/project"> 项目管理 </a-menu-item>
            <a-menu-item key="/userCenter/supply"> 供应管理 </a-menu-item>
            <a-menu-item key="/userCenter/demand"> 需求管理 </a-menu-item>
            <a-menu-item key="/userCenter/shen"> 政策申报 </a-menu-item>
          </a-sub-menu>

          <a-sub-menu key="sub5">
            <span slot="title"><a-icon type="mail" /><span>咨询服务</span></span>
            <a-menu-item key="/userCenter/consulting"> 咨询记录管理 </a-menu-item>
          </a-sub-menu>
        </a-menu>
      </div>
      <div class="user-center-right">
        <router-view />
      </div>
    </div>
  </div>
</template>
<script>
export default {
  name: "user-center",
  data() {
    return {
      list: [{ id: {} }],
    };
  },
  mounted() {
    const userInfo = localStorage.getItem("userInfo");

    if (userInfo == null) {
      this.$router.push({ path: "/login" });
      // this.userInfo = JSON.parse(userInfo);
      // console.log(this.userInfo.menuVOS);
    }
  },
  methods: {
    handleClick({ item, key, keyPath }) {
      console.log(item, key, keyPath);
      this.$router.push(`${key}`);
    },
  },
};
</script>

<style lang="less">
.userCenter {
  min-height: 800px;
  .tool-box {
    padding: 20px;
  }
  .banner {
    width: 100%;
    height: 140px;
    background: #ddd;
    .logo-box {
      width: 310px;
      height: 140px;
      background: #fff;
      img {
        width: 100%;
        height: 100%;
        object-fit: contain;
      }
    }
  }
  .user-center-left {
    width: 310px;
  }
  .user-center-right {
    width: 90%;
    background: #fff;
    min-height: 600px;
    .ant-table td {
      white-space: nowrap;
    }
  }
}
</style>
